module.exports = __webpack_public_path__ + "img/mabang-logo.f51500e2.png";